import i18n from "../i18n/i18n";

const MultiSelectDropdown = {
    oninit: function () {
        this.searchQuery = "";
    },
    view: function (vnode) {
        const {
            label,
            options,
            selected,
            onChange,
            getLabel,
            getValue,
            allLabel,
            optionGroups,  // optional: [{label: string, items: array}] for grouped display
            searchable     // optional: show a search field inside the dropdown
        } = vnode.attrs;

        const self = this;
        const q = (self.searchQuery || "").toLowerCase();

        function matchesSearch(item) {
            if (!q) return true;
            return getLabel(item).toLowerCase().indexOf(q) !== -1;
        }

        function renderItem(item) {
            const value = getValue ? getValue(item) : item;
            const isSelected = selected.includes(value);
            return m("div", {
                class: "flex align-center " + (isSelected ? "active" : ""),
                onclick: () => {
                    const newSelected = isSelected
                        ? selected.filter(c => c !== value)
                        : [...selected, value];
                    onChange(newSelected);
                }
            }, [
                m("i", { class: isSelected ? "icon-checkbox-checked mr-2" : "icon-checkbox-empty mr-2" }),
                getLabel(item)
            ]);
        }

        function renderOptions() {
            if (optionGroups && optionGroups.length > 0) {
                const nodes = [];
                let anyVisible = false;
                optionGroups.forEach(function (group) {
                    const visibleItems = group.items.filter(matchesSearch);
                    if (visibleItems.length === 0) return;
                    anyVisible = true;
                    if (group.label) {
                        nodes.push(m(".dropdown-section-label", {
                            style: "padding: 0.4rem 0.8rem; font-size: 0.75rem; opacity: 0.6; cursor: default",
                            onclick: function (e) { e.stopPropagation(); }
                        }, group.label));
                    }
                    visibleItems.forEach(item => nodes.push(renderItem(item)));
                });
                if (!anyVisible) {
                    nodes.push(m("div", { style: "padding: 0.5rem 0.8rem; font-size: 0.875rem; opacity: 0.6;" }, i18n.t("no_results")));
                }
                return nodes;
            }
            const visible = (options || []).filter(matchesSearch);
            if (visible.length === 0) {
                return [m("div", { style: "padding: 0.5rem 0.8rem; font-size: 0.875rem; opacity: 0.6;" }, i18n.t("no_results"))];
            }
            return visible.map(renderItem);
        }

        return m('.dropdown', [
            m('button.btn.btn-secondary.btn-lg pl-2 pr-1 ml-2 w-200', [
                label(),
                m("i.icon-back.rotate-270.ml-2")
            ]),
            m('.dropdown-list mb-0 pb-0', { style: "min-width: 220px;" }, [
                searchable
                    ? m("div", {
                        style: "padding: 0.4rem 0.5rem; border-bottom: 1px solid var(--border-color, #e5e7eb);",
                        onclick: function (e) { e.stopPropagation(); }
                    }, [
                        m("input[type=text]", {
                            placeholder: i18n.t("search"),
                            value: self.searchQuery,
                            oninput: function () { self.searchQuery = this.value; },
                            onkeydown: function (e) {
                                if (e.key === "Escape") { self.searchQuery = ""; }
                                e.stopPropagation();
                            },
                            oncreate: function (vnode) { vnode.dom.focus(); },
                            style: "width: 100%; padding: 0.25rem 0.4rem; font-size: 0.875rem; border: 1px solid var(--border-color, #d1d5db); border-radius: 4px;"
                        })
                    ])
                    : null,
                m("div", {
                    class: selected.length === 0 ? "active" : "",
                    onclick: () => { onChange([]); self.searchQuery = ""; }
                }, allLabel),
                renderOptions()
            ])
        ]);
    }
};

export default MultiSelectDropdown;
